import get from 'lodash/get';

const RUNNING_STATES = ['created', 'in progress', 'postprocessing'];

/**
 * A background runner that aborted before creating any task stores `executions.success: false`
 * but still ends up in state 'done' with 0 task errors, so on its own the list shows it as a
 * successful job with an unexplained, greyed-out download button.
 */
export default {
  name: 'BackgroundJobFailureMixin',
  methods: {
    // The user-facing reason a job failed, or null if it did not fail.
    jobFailureReason(item) {
      if (get(item, 'executions.success') !== false) {
        return null;
      }
      const codeKey = `BackgroundJobs.BackgroundJobs.failureCodes.${get(item, 'executions.errorCode')}`;
      if (this.$i18n_te(codeKey)) {
        return this.$i18n_t(codeKey);
      }
      // Jobs without an errorCode — older rows, and the single-export / bulk-import failure
      // paths — only have the raw error string. UNKNOWN is the last resort when even that
      // is missing.
      return get(item, 'executions.error') || this.$i18n_t('BackgroundJobs.BackgroundJobs.failureCodes.UNKNOWN');
    },
    // Why the export cannot be downloaded, or null when the file is available.
    jobDownloadHint(item) {
      const failureReason = this.jobFailureReason(item);
      if (failureReason) {
        return failureReason;
      }
      if (RUNNING_STATES.includes(get(item, 'state'))) {
        return this.$i18n_t('BackgroundJobs.BackgroundJobs.download.stillRunning');
      }
      if (get(item, 'state') === 'canceled') {
        return this.$i18n_t('BackgroundJobs.BackgroundJobs.download.canceled');
      }
      if (get(item, 'executions.result.data.deletedAt')) {
        return this.$i18n_t('BackgroundJobs.BackgroundJobs.cleanupInfo');
      }
      if (!get(item, 'executions.result.data.fileId')) {
        return this.$i18n_t('BackgroundJobs.BackgroundJobs.download.noFile');
      }
      return null;
    },
  },
};
